// extracted by css-extract-rspack-plugin
export default {"cls1":"FallbackBulkDownloadUpsellModalControl-cls1_hAe","cls2":"FallbackBulkDownloadUpsellModalControl-cls2_72A FallbackBulkDownloadUpsellModalControl-cls1_hAe"};